// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Branches from './Branches';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Branches);
